module.exports = __webpack_public_path__ + "img/hy_icon2.e0fdf866.png";